<template>
  <footer class="footer">
    <div class="text-center mt-4">
      <small class="text-muted"> © {{new Date().getFullYear()}} Östorps </small>
    </div>
  </footer>
</template>